import {ArrowBack} from '@mui/icons-material';
import {Box, Button, Stack} from '@mui/material';

export interface StudyPageHeaderProps {
  onBack: () => void;
  onToggleToc?: () => void;
  showTocButton?: boolean;
}

export default function StudyPageHeader({onBack, onToggleToc, showTocButton}: StudyPageHeaderProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={{xs: 1, md: 2}}
      sx={{mb: {xs: 2, md: 3}}}
      data-testid="study-page-header"
    >
      <Button startIcon={<ArrowBack />} onClick={onBack} sx={{minWidth: 'auto'}} data-testid="study-page-back-button">
        Back
      </Button>
      <Box sx={{flex: 1}} />
      {showTocButton && onToggleToc && (
        <Button onClick={onToggleToc} variant="outlined" size="small" data-testid="study-page-toc-button">
          TOC
        </Button>
      )}
    </Stack>
  );
}
